export const DASHBOARD_HERO_HEIGHT = 272;
